"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ImageTagsServiceClient_1 = __importDefault(require("./ImageTagsServiceClient"));
const client_library_1 = require("@seneca/client-library");
exports.MissingParamError = client_library_1.MissingParamError;
exports.RequestLimitExceeded = client_library_1.RequestLimitExceeded;
exports.UnexpectedServerResponse = client_library_1.UnexpectedServerResponse;
exports.UrlConstructionError = client_library_1.UrlConstructionError;
exports.default = ImageTagsServiceClient_1.default;
